import {
  Avatar,
  Grid,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Typography,
} from "@mui/material";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import { useTranslation } from "react-i18next";
import ForumIcon from "@mui/icons-material/Forum";
import { TikTokIcon } from "../../../components/icons/Icons";
import FacebookIcon from "@mui/icons-material/Facebook";
import { PageHeader } from "../../../components/PageHeader";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import { useEffect, useState } from "react";
import { getKeywordSource } from "../../../api/specialization/KeywordSpecializationAPI";
import { sourcesToElements } from "../../../components/popup/ContentListPopup";
import React from "react";
import { ContentDetailPopup } from "../../../components/ContentDetailPopup";
import { getFromStorage } from "../../../util/StorageUtil";
import { whatsnew } from "../../../api/content/ContentAPI";

export function WhatsNewPage() {
  const { t } = useTranslation(["common", "whatsnew", "keyword"]);
  const [currentText, setCurrentText] = useState(
    getFromStorage("homePageData12")
      ? getFromStorage("homePageData12").popularKeywords[0].token
      : "Việt Nam"
  );
  const [chosenKeyword, setChosenKeyword] = useState(
    getFromStorage("homePageData12")
      ? getFromStorage("homePageData12").popularKeywords[0].token
      : "Việt Nam"
  );
  const [newsSources, setNewsSources] = useState([]);
  const [forumSources, setForumSources] = useState([]);
  const [showNewsDetailPopup, setShowNewsDetailPopup] = useState(false);
  const [chosenNewsID, setChosenNewsID] = useState(0);

  let elements = newsSources.map(function (source) {
    return (
      <ListItem
        alignItems="flex-start"
        className="source-item"
        onClick={() => {
          setShowNewsDetailPopup(true);
          setChosenNewsID(source["id"]);
        }}
      >
        <ListItemAvatar>
          <Avatar
            alt={source["source"]}
            src={
              "https://www.google.com/s2/favicons?domain=" +
              new URL(source["url"]).hostname +
              "/favicon.ico"
            }
          />
        </ListItemAvatar>
        <ListItemText
          style={{ textAlign: "justify" }}
          primary={source["title"]}
          primaryTypographyProps={{
            fontSize: "15px",
            color: "#1976d2",
            fontWeight: 500,
          }}
          secondaryTypographyProps={{
            fontSize: "13px",
          }}
          secondary={
            <React.Fragment>
              <Typography
                sx={{ display: "inline", fontSize: "12px" }}
                component="span"
                variant="body2"
                color="text.primary"
              >
                {source["author"]}
              </Typography>
              {(source["author"] ? " - " : "") + source["description"]}
            </React.Fragment>
          }
        />
      </ListItem>
    );
  });

  let forumElements = forumSources.map(function (source) {
    return (
      <ListItem
        alignItems="flex-start"
        className="source-item"
        onClick={() => {
          // setShowNewsDetailPopup(true);
          // setChosenNewsID(source["id"]);
        }}
      >
        <ListItemAvatar>
          <Avatar
            alt={source["source"]}
            src={
              "https://www.google.com/s2/favicons?domain=" +
              new URL(source["url"]).hostname +
              "/favicon.ico"
            }
          />
        </ListItemAvatar>
        <ListItemText
          style={{ textAlign: "justify" }}
          primary={source["title"]}
          primaryTypographyProps={{
            fontSize: "15px",
            color: "#1976d2",
            fontWeight: 500,
          }}
          secondaryTypographyProps={{
            fontSize: "13px",
          }}
          secondary={
            <React.Fragment>
              <Typography
                sx={{ display: "inline", fontSize: "12px" }}
                component="span"
                variant="body2"
                color="text.primary"
              >
                {source["author"]}
              </Typography>
              {(source["author"] ? " - " : "") + source["content"]}
            </React.Fragment>
          }
        />
      </ListItem>
    );
  });
  const middleIndex = Math.ceil(elements.length / 2);

  const firstHalfElements = elements.slice().splice(0, middleIndex);
  const secondHalfElements = elements.slice().splice(-middleIndex);

  const forumMiddleIndex = Math.ceil(forumElements.length / 2);
  let firstHalfForums = forumElements.slice().splice(0, forumMiddleIndex);
  let secondHalfForumElements = forumElements.slice().splice(-forumMiddleIndex);
  useEffect(() => {
    whatsnew()
      .then((res) => {
        setNewsSources(res["newsArticles"].slice(0, 10));
        setForumSources(res["forumArticles"].slice(0, 10));
      })
      .catch((err) => {});
  }, [chosenKeyword]);
  return (
    <Grid container xs={12}>
      <Grid container xs={12}>
        <ContentDetailPopup
          id={chosenNewsID}
          popup={showNewsDetailPopup}
          onClosePopup={() => {
            setShowNewsDetailPopup(false);
            setChosenNewsID(0);
          }}
        />
      </Grid>
      <Grid item xs={1}></Grid>
      <Grid container xs={10} className="white" marginTop={3}>
        <PageHeader
          noIndent={true}
          leftIcon={
            <NewspaperIcon
              color="info"
              sx={{
                marginRight: "10px",
                marginLeft: "10px",
                width: "30px",
                height: "30px",
              }}
            />
          }
          text={t("whatsnew:news_articles")}
        ></PageHeader>
        <Grid item xs={5.85}>
          <List
            style={{ display: "flex", flexDirection: "column", padding: 0 }}
          >
            {firstHalfElements}
          </List>
        </Grid>
        <Grid item xs={0.3}></Grid>
        <Grid item xs={5.85}>
          <List
            style={{ display: "flex", flexDirection: "column", padding: 0 }}
          >
            {secondHalfElements}
          </List>
        </Grid>
      </Grid>
      <Grid item xs={1}></Grid>
      <Grid item xs={1}></Grid>
      <Grid container xs={10} className="white" marginTop={3}>
        <PageHeader
          noIndent={true}
          leftIcon={
            <ForumIcon
              color="secondary"
              sx={{
                marginRight: "10px",
                marginLeft: "10px",
                width: "30px",
                height: "30px",
              }}
            />
          }
          text={t("whatsnew:forum_articles")}
        ></PageHeader>
        <Grid item xs={5.85}>
          <List
            style={{ display: "flex", flexDirection: "column", padding: 0 }}
          >
            {firstHalfForums}
          </List>
        </Grid>
        <Grid item xs={0.3}></Grid>
        <Grid item xs={5.85}>
          <List
            style={{ display: "flex", flexDirection: "column", padding: 0 }}
          >
            {secondHalfForumElements}
          </List>
        </Grid>
      </Grid>
      <Grid item xs={1}></Grid>
    </Grid>
  );
}
